export const SNOWPACK_PUBLIC_SITENAME = "\u682A\u5F0F\u4F1A\u793E\u30A2\u30EB\u30D9\u30ED";
export const SNOWPACK_PUBLIC_SITEURL = "https://lalbero.co.jp";
export const SNOWPACK_PUBLIC_ENDPOINT = "https://wordpress.lalbero.co.jp/graphql";
export const SNOWPACK_PUBLIC_CONTACT_ENDPOINT = "https://wordpress.lalbero.co.jp/wp-json/contact-form-7/v1/contact-forms/5/feedback";
//# sourceMappingURL=index.js.map
